"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = require("react");
function e(t, o) {
  return (e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  })(t, o);
}
var o = function (o) {
  var n, r;
  function i() {
    var t;
    return (t = o.apply(this, arguments) || this).getInitialState = function () {
      var e = t.props,
        o = e.pandx,
        n = e.pandy,
        r = e.zoom;
      return {
        comesFromDragging: !1,
        dragData: {
          dx: o,
          dy: n,
          x: 0,
          y: 0
        },
        dragging: !1,
        matrixData: [r, 0, 0, r, o, n],
        mouseDown: !1
      };
    }, t.state = t.getInitialState(), t.reset = function () {
      t.setState({
        matrixData: [.4, 0, 0, .4, 0, 0]
      }), t.props.onReset && t.props.onReset(0, 0, 1);
    }, t.onClick = function (e) {
      t.state.comesFromDragging || t.props.onClick && t.props.onClick(e);
    }, t.onTouchStart = function (e) {
      var o = e.touches[0];
      t.panStart(o.pageX, o.pageY, e);
    }, t.onTouchEnd = function () {
      t.onMouseUp();
    }, t.onTouchMove = function (e) {
      t.updateMousePosition(e.touches[0].pageX, e.touches[0].pageY);
    }, t.onMouseDown = function (e) {
      t.panStart(e.pageX, e.pageY, e);
    }, t.panStart = function (e, o, n) {
      if (t.props.enablePan) {
        var r = t.state.matrixData;
        t.setState({
          dragData: {
            dx: r[4],
            dy: r[5],
            x: e,
            y: o
          },
          mouseDown: !0
        }), t.panWrapper && (t.panWrapper.style.cursor = "move"), n.stopPropagation(), n.nativeEvent.stopImmediatePropagation(), n.preventDefault();
      }
    }, t.onMouseUp = function () {
      t.panEnd();
    }, t.panEnd = function () {
      t.setState({
        comesFromDragging: t.state.dragging,
        dragging: !1,
        mouseDown: !1
      }), t.panWrapper && (t.panWrapper.style.cursor = ""), t.props.onPan && t.props.onPan(t.state.matrixData[4], t.state.matrixData[5]);
    }, t.onMouseMove = function (e) {
      t.updateMousePosition(e.pageX, e.pageY);
    }, t.onWheel = function (e) {
      Math.sign(e.deltaY) < 0 ? t.props.setZoom((t.props.zoom || 0) + .1) : (t.props.zoom || 0) > 1 && t.props.setZoom((t.props.zoom || 0) - .1);
    }, t.onMouseEnter = function () {
      document.addEventListener("wheel", t.preventDefault, {
        passive: !1
      });
    }, t.onMouseLeave = function () {
      document.removeEventListener("wheel", t.preventDefault, !1);
    }, t.updateMousePosition = function (e, o) {
      if (t.state.mouseDown) {
        var n = t.getNewMatrixData(e, o);
        t.setState({
          dragging: !0,
          matrixData: n
        }), t.panContainer && (t.panContainer.style.transform = "matrix(" + t.state.matrixData.toString() + ")");
      }
    }, t.getNewMatrixData = function (e, o) {
      var n = t.state,
        r = n.dragData,
        i = n.matrixData,
        a = r.y - o;
      return i[4] = r.dx - (r.x - e), i[5] = r.dy - a, i;
    }, t;
  }
  r = o, (n = i).prototype = Object.create(r.prototype), n.prototype.constructor = n, e(n, r);
  var a = i.prototype;
  return a.UNSAFE_componentWillReceiveProps = function (t) {
    if (this.state.matrixData[0] !== t.zoom) {
      var e = [].concat(this.state.matrixData);
      e[0] = t.zoom || e[0], e[3] = t.zoom || e[3], this.setState({
        matrixData: e
      });
    }
  }, a.render = function () {
    var e = this;
    return t.createElement("div", {
      className: "pan-container " + (this.props.className || ""),
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      onTouchStart: this.onTouchStart,
      onTouchMove: this.onTouchMove,
      onTouchEnd: this.onTouchEnd,
      onMouseMove: this.onMouseMove,
      onWheel: this.onWheel,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: this.onClick,
      style: {
        height: this.props.height,
        userSelect: "none",
        width: this.props.width
      },
      ref: function (t) {
        return e.panWrapper = t;
      }
    }, t.createElement("div", {
      ref: function (t) {
        return t ? e.panContainer = t : null;
      },
      style: {
        transform: "matrix(" + this.state.matrixData.toString() + ")"
      }
    }, this.props.children));
  }, a.preventDefault = function (t) {
    (t = t || window.event).preventDefault && t.preventDefault(), t.returnValue = !1;
  }, i;
}(t.PureComponent);
o.defaultProps = {
  enablePan: !0,
  onPan: function () {},
  onReset: function () {},
  pandx: 0,
  pandy: 0,
  zoom: 0,
  rotation: 0
}, exports.PanViewer = o, exports.default = function (e) {
  var n = e.image,
    r = e.alt,
    i = e.ref,
    a = t.useState(0),
    s = a[0],
    p = a[1],
    c = t.useState(0),
    u = c[0],
    d = c[1],
    l = t.useState(1),
    h = l[0],
    g = l[1],
    m = t.useState(0),
    f = m[0],
    x = m[1],
    v = t.useState(!1),
    w = v[0],
    k = v[1];
  return t.createElement("div", null, t.createElement("div", {
    style: {
      position: "absolute",
      right: "10px",
      zIndex: 2,
      top: 10,
      userSelect: "none",
      borderRadius: 2,
      background: "#fff",
      boxShadow: "0px 2px 6px rgba(53, 67, 93, 0.32)"
    }
  }, t.createElement("div", {
    onClick: function () {
      g(h + .2);
    },
    style: {
      textAlign: "center",
      cursor: "pointer",
      height: 40,
      width: 40,
      borderBottom: " 1px solid #ccc"
    }
  }, t.createElement("svg", {
    style: {
      height: "100%",
      width: "100%",
      padding: 10,
      boxSizing: "border-box"
    },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M4 12H20",
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), t.createElement("path", {
    d: "M12 4L12 20",
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round"
  }))), t.createElement("div", {
    onClick: function () {
      h >= 1 && g(h - .2);
    },
    style: {
      textAlign: "center",
      cursor: "pointer",
      height: 40,
      width: 40,
      borderBottom: " 1px solid #ccc"
    }
  }, t.createElement("svg", {
    style: {
      height: "100%",
      width: "100%",
      padding: 10,
      boxSizing: "border-box"
    },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M4 12H20",
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round"
  }))), t.createElement("div", {
    onClick: function () {
      x(-3 === f ? 0 : f - 1);
    },
    style: {
      textAlign: "center",
      cursor: "pointer",
      height: 40,
      width: 40,
      borderBottom: " 1px solid #ccc"
    }
  }, t.createElement("svg", {
    style: {
      height: "100%",
      width: "100%",
      padding: 10,
      boxSizing: "border-box"
    },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    d: "M14 15L9 20L4 15",
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), t.createElement("path", {
    d: "M20 4H13C10.7909 4 9 5.79086 9 8V20",
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), t.createElement("div", {
    onClick: function () {
      k(!w);
    },
    style: {
      textAlign: "center",
      cursor: "pointer",
      height: 40,
      width: 40,
      borderBottom: " 1px solid #ccc"
    }
  }, t.createElement("svg", {
    style: {
      height: "100%",
      width: "100%",
      padding: 10,
      boxSizing: "border-box"
    },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t.createElement("path", {
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.178,18.799V1.763L0,18.799H9.178z M8.517,18.136h-7.41l7.41-13.752V18.136z"
  }), t.createElement("polygon", {
    stroke: "#4C68C1",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "11.385,1.763 11.385,18.799 20.562,18.799 "
  }))), t.createElement("div", {
    onClick: function () {
      p(0), d(0), g(1), x(0), k(!1);
    },
    style: {
      textAlign: "center",
      cursor: "pointer",
      height: 40,
      width: 40
    }
  }, t.createElement("svg", {
    style: {
      height: "100%",
      width: "100%",
      padding: 10,
      boxSizing: "border-box"
    },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#4C68C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, t.createElement("path", {
    d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
  })))), t.createElement(o, {
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1
    },
    zoom: h,
    setZoom: g,
    pandx: s,
    pandy: u,
    onPan: function (t, e) {
      p(t), d(e);
    },
    rotation: f,
    key: s
  }, t.createElement("img", {
    style: {
      transform: "rotate(" + 90 * f + "deg) scaleX(" + (w ? -1 : 1) + ")",
      width: "100%"
    },
    src: n,
    alt: r,
    ref: i
  })));
};